/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true, pressed: true },
      tokens: { color: '#163e06', outlineColor: '#163e06' }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#2b8000',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 1.5,
    outlineColor: '#2b8000',
    outlineOffset: 0,
    outlineStyle: 'solid',
    outlineWidth: 2,
    paddingHorizontal: 2,
    paddingVertical: 2,
    textLine: 'underline'
  }
}
export default theme
